import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../../lib/auth";
import withPermission from "../../hoc/withPermission";
import { StudentHeader } from "../components";

class PrivateStudentRoute extends React.Component {
  render() {
    const {
      permission,
      hasPermission,
      component: Component,
      ...rest
    } = this.props;

    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated() && (!permission || hasPermission(permission)) ? (
            <>
              <StudentHeader />
              <div className="content-top">
                <Component {...props} />
              </div>
            </>
          ) : (
            <Redirect to="/login" />
          )
        }
      />
    );
  }
}

PrivateStudentRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.func,
  ]),
};

PrivateStudentRoute.defaultProps = {
  component: null,
};

export default withPermission(PrivateStudentRoute);
